/* eslint-disable  max-lines*/
/* eslint-disable  max-statements*/
/* eslint-disable require-jsdoc */
/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable no-inline-comments */
/* eslint-disable line-comment-position */
/* eslint-disable max-lines-per-function */
(function() {
  /* eslint-disable vars-on-top */
  /* eslint-disable xss/no-mixed-html */
  /* eslint-disable no-use-before-define */

  var dttxtAdd = '.phi-datepicker-address';

  bindAddressSelection();

  function bindAddressSelection() { // NOSONAR
    var dttxt = '.phi-datepicker';


    $('.use_address')
      .click(function() {
        var addrId = $(this).attr('data-address-id');
        var addrType = $(this).attr('data-address-type');
        var prevAddr = $('.ph-selected_addr').attr('data-addr');

        if (prevAddr === addrId) {
          $.colorbox.close();
        } else {
          $('.ph-selected_addr').attr('data-addr', addrId);
          updateDateAndAddress(addrId, addrType);
        }
      });

    var $datePicker = $(dttxt),
        $datePickerAdd = $(dttxtAdd),
        blockDays = $datePicker.attr('data-blockdays');

    if ($datePicker.length > 0) {
      var dateObj = new Date();
      var hdTime = $datePicker.attr('data-mindate');
      var reqDate = $('#representante_legal').val();

      var maxFut = $datePicker.attr('data-maxdate');
      var maxFutMil = parseInt(maxFut, 10) * parseInt(86400000, 10);

      var dateObjMax = new Date();

      dateObj.setTime(hdTime);
      dateObjMax.setTime(parseInt(hdTime, 10) + parseInt(maxFutMil, 10));

      $datePicker.datepicker({
        changeMonth: true,
        changeYear: true,
        showButtonPanel: true,
        closeText: reqDate,
        minDate: dateObj,
        maxDate: dateObjMax,
        beforeShow: function() {
          $('#ui-datepicker-div').addClass('ph-checkout-datepicker');
        },
        beforeShowDay: myCheck,
        dateFormat: $('.ph-requestDeliverDateFormat').val().toLowerCase().replace('yyyy', 'yy'),
        onSelect: function(dateText, inst) {
          inst.show();
        }
      });
    }

    function myCheck(inDate) {
      var currentDay = inDate.getDay(),
          isDayAvailable = dayCheck(currentDay),
          unloadingString = 'unloading',
          addressUnloading = $datePickerAdd.attr('address-' + unloadingString),
          noWeekend = $.datepicker.noWeekends(inDate),
          noWeekendavalue = noWeekend[0],
          noHolidayavalue = true,
          dateStr = inDate.toDateString(),
          dateStrArr = dateStr.split(' '),
          curDay = dateStrArr[0],
          curMonth = dateStrArr[1],
          curDate = dateStrArr[2],
          holArr = $('.phi-datepicker-address').attr('address-holiday'),
          holArrRemoveLeft = holArr.replace('[', ''),
          holArrRemoveRight = holArrRemoveLeft.replace(']', ''),
          holArrNew = holArrRemoveRight.split(', '),
          holArrNewLength = holArrNew.length;

      for (var start = 0; start < holArrNewLength; start = start + 1) {
        var newArr = holArrNew[start].split(' ');

        if (curMonth === newArr[1] && curDate === newArr[2] && curDay === newArr[0]) {
          noHolidayavalue = false;
        }
      }

      if (noWeekendavalue === false || noHolidayavalue === false) {
        return [
          true,
          'ui-datepicker-unselectable ui-state-disabled ph-hol'
        ];
      }

      if (addressUnloading === 'true') {
        if (isDayAvailable === 'true') {
          return [
            true,
            'ph-av'
          ];
        }

        if (blockDays === 'true') {
          return [
            false,
            'ph-notav'
          ];
        }

        return [
          true,
          'av'
        ];
      }

      return [
        true,
        'av'
      ];


      function dayCheck(currentDayHere) {
        var daysArray = [
          'sun',
          'mon',
          'tue',
          'wed',
          'thu',
          'fri',
          'sat'
        ];
        var currentDayWord = daysArray[currentDayHere];
        var currentDayAttribute = $datePickerAdd.attr('address-' + currentDayWord);

        if (currentDayAttribute === 'true') {
          return 'true';
        }

        return 'false';
      }
    }

    $('.phi-entry-datepicker').each(function() {
      if ($(this).length > 0) {
        var dte = new Date();
        var entryTime = $(this).attr('data-mindate');

        dte.setTime(entryTime);
        $(this).datepicker({
          changeMonth: true,
          changeYear: true,
          minDate: dte,
          dateFormat: $('.ph-requestDeliverDateFormat').val().toLowerCase().replace('yyyy', 'yy')
        });
      }
    });

    var $doc = $(document);

    $doc.on('click', '.ph-rddChangeYes', function() {
      $.colorbox.close();

      var $dpInput = $(dttxt),
          date = $dpInput.val(),
          addressId = $('#filterAddressId').val(),
          txtSapCart = '.sapCartMessages';

      $(txtSapCart).html('');
      $(txtSapCart).addClass('hidden');
      $('.phi-rdd-alert').each(function() {
        $(this).html('');
      });
      updateDateAndAddress(addressId, date);
    });

    $doc.on('click', '.phi-entry-datepicker-cont', function() {
      $(this).find('.phi-entry-datepicker').datepicker('show');
    });

    $doc.on('click', '#alert-close', function() {
      $(this).parent().parent().addClass('hidden');
    });
  }

  function enableCheckoutButton($placeOrderButton, $cartMessages) {
    var disablemeBtn = 'ph-disable-button',
        poNumberCheckMandatory = $('#ph-emptyPoNumber').val();

    $cartMessages.addClass('hidden');

    if ($('#termsCheck').prop('checked') && $('#purchaseOrderNumber').val() !== '' && poNumberCheckMandatory === 'true') {
      $placeOrderButton.removeClass(disablemeBtn);
    } else if ($('#termsCheck').prop('checked') && poNumberCheckMandatory === 'false') {
      $placeOrderButton.removeClass(disablemeBtn);
    }
  }

  function updateDateAndAddress(addressId, addrType) {
    var $placeOrderButton = $('.ph-shipping__procceed'),
        sapmsg = '-sapaddresserror',
        pointEvent = 'pointer-events';

    $('.ph-vanish-ajax').empty();
    $('.ph' + sapmsg).empty();
    $('.ph-del-addr-error').hide();
    $placeOrderButton.removeClass('ph-disable__checkout');
    $('.ph-address__error').hide();

    var adrurl = ACC.config.encodedContextPath + '/checkout/single/updateAddress.json';
    var adrdata = {
      addressID: addressId
    };

    if (addrType === 'consignee') {
      adrurl = ACC.config.encodedContextPath + '/checkout/single/updateConsigneeAddress';
      adrdata = {
        consigneeAddressId: addressId
      };
    }

    var phseltick = '.ph-del-address-items .ph-selected-tick';

    var phseltickcon = '.ph-con-address-items .ph-selected-tick';

    $('[data-address-id="' + addressId + '"]').find('.ph-adr-loader').show();
    $('.ph-existing_address').not('[data-address-id=\' ' + addressId + ' \']').css(pointEvent, 'none');
    $.ajax({
      url: adrurl,
      data: adrdata,
      type: 'POST',
      success: function(result) {
        $('.ph-adr-loader').hide();
        $('.ph-existing_address').css(pointEvent, 'auto');

        if (addrType === 'delivery') {
          $(phseltick).hide();
        } else if (addrType === 'consignee') {
          $(phseltickcon).hide();
        }

        updatSelectedAddress(result, addrType, addressId);

        var messages = '';
        var $cartMessages = $('.ph-sapaddresserror');

        for (var messagecount = 0; messagecount < result.messages.length; messagecount = messagecount + 1) {
          var message = result.messages[messagecount],
              divstr = '</div>',
              msgstat = ACC.address.updatecartmessagestatus(message.messageClass),
              msgkeystat = ACC.address.messageStatCheck(message.messageKey);

          /* eslint-disable no-negated-condition */
          var errorHtmlData = '<div class="ph-row ph-p-0 ph-ml-0 ph-col-12 ' + message.messageClass + '">' +
            '<div class="' + msgstat + ' ph-float-left ph-p-1 ph-pr-2 ph-mt-1 ph-mb-1 ph-col-12 ph-msglen" data-id="' +
            message.messageKey + '" id="' + msgkeystat + '">' + message.statusMessage + divstr + '</div>';

          messages = messages + errorHtmlData;


          $cartMessages.html(messages);
        }

        var isUnloadingFlag = result.deliveryAddress.isUnloadingDataPresent,
            avMon = result.deliveryAddress.monday,
            avTue = result.deliveryAddress.tuesday,
            avWed = result.deliveryAddress.wednesday,
            avThu = result.deliveryAddress.thursday,
            avFri = result.deliveryAddress.friday,
            avSat = result.deliveryAddress.saturday,
            avSun = result.deliveryAddress.sunday,
            avHol = result.deliveryAddress.holidayList,
            avHolUpdate = [],
            dttxtAddHere = dttxtAdd,
            $datePickerAddHere = $(dttxtAddHere);

        for (var increment = 0; increment < avHol.length; increment = increment + 1) {
          var dateObject = new Date();

          dateObject.setTime(avHol[increment]);

          if (increment === 0) {
            avHolUpdate.push(dateObject);
          } else {
            avHolUpdate.push(' ' + dateObject);
          }
        }

        $datePickerAddHere.attr('address-unloading', isUnloadingFlag);
        $datePickerAddHere.attr('address-mon', avMon);
        $datePickerAddHere.attr('address-tue', avTue);
        $datePickerAddHere.attr('address-wed', avWed);
        $datePickerAddHere.attr('address-thu', avThu);
        $datePickerAddHere.attr('address-fri', avFri);
        $datePickerAddHere.attr('address-sat', avSat);
        $datePickerAddHere.attr('address-sun', avSun);
        $datePickerAddHere.attr('address-holiday', avHolUpdate);

        if (messages !== '') {
          $cartMessages.removeClass('hidden');
          ACC.address.enablecartButCheck($('#ph-show-but').length, $('#backorderFlag').val(), $placeOrderButton);
        } else {
          enableCheckoutButton($placeOrderButton, $cartMessages);
        }
      },
      error: function() {
        $('.ph-con-addr-error').show();
      }
    });
  }

  /* eslint-enable no-negated-condition */
  function checknull(dta) {
    if (dta) {
      return dta;
    }

    return '';
  }

  /* eslint-disable id-length */
  function updatSelectedAddress(result, addrType, addressId) {
    var selConTick = 'selected-tick',
        consAddrSel = '.ph-cons-addr',
        phSelectAddr = 'ph-selected-add',
        orderBtn = 'order-button';

    if (addrType === 'consignee' && result === '') {
      $('.ph-con-address-items [data-address-id="' + addressId + '"]').find('.ph-' + selConTick).show();
      $(consAddrSel).removeClass(phSelectAddr).html('');
      $('.ph-no-cons-text').removeClass('hidden');
      $.colorbox.close();
    }

    if (result.deliveryAddress.id) {
      if (addrType === 'delivery') {
        $('.ph-del-address-items [data-address-id="' + addressId + '"]').find('.ph-selected-tick').show();
      } else if (addrType === 'consignee') {
        $('.ph-con-address-items [data-address-id="' + addressId + '"]').find('.ph-selected-tick').show();
      }

      var adt = result.deliveryAddress;

      if (addrType === 'delivery') {
        var brTag = '<br>',
            clearCompanyName = adt.company.replace(/[()]/g, ''),
            addressArray = adt.formattedAddress.split(','),
            countryName = addressArray[addressArray.length - 1],
            addressLength = addressArray.length,
            shippingAddress = '',
            streetName = '',
            formatterShippingAddress = '';

        addressArray.pop();
        $.each(addressArray, function(index, value) {
          if (index > addressLength - 5) {
            shippingAddress = shippingAddress + (value + ', ');
          } else {
            streetName = streetName + (value + ', ');
          }
        });
        shippingAddress = shippingAddress.trim().replace(/.$/, '');
        streetName = streetName.trim().replace(/.$/, '');
        formatterShippingAddress = formatterShippingAddress + (adt.sapCustomerID + ' - ' + clearCompanyName + brTag +
          streetName + brTag +
          shippingAddress + brTag +
          countryName);

        $('.ph-del-addr').html(checknull(formatterShippingAddress));

        $.colorbox.close();
      } else if (addrType === 'consignee') {
        var cdt = result.ultimateConsigneeAddress;

        $(consAddrSel).addClass(phSelectAddr).html(checknull(cdt.sapCustomerID) + ',' + checknull(cdt.formattedAddress) +
          ' ' + checknull(cdt.company));
        $('#Place-' + orderBtn).removeClass('ph-shipping__procceed-disable').prop('disabled', false);
        $.colorbox.close();
      }
    } else {
      $('.ph-con-addr-error').show();
    }
  }

  $(document).on('click', '.ph-errormessage', function() {
    $('.sapCartMessages').addClass('hidden');
  });

  function loadProductCondition(result, index) {
    var product = result[index],
        priceList = result[index].priceList,
        discVal = result[index].discountPromotion,
        prodRow = '#ph-pl-row-',
        $isPromotionEnabled = $('.ph-promotionenabled'),
        freeMarketingProductVal = $(prodRow + product.code).find('.ph-freeMarketingProductCls').val(),
        freePriceText = $('.ph-freePriceText').val();

    if (priceList.length > 0) {
      var pricesHtml = '',
          addStrikeClass = '',
          ribbonText = $(prodRow + product.code).find('.ph-discount-ribbon__text').html();

      for (var priceIndex = 0; priceIndex < priceList.length; priceIndex = priceIndex + 1) {
        var priceRow = priceList[priceIndex];

        addStrikeClass = '';

        if (priceRow.priceType === 'FROM' && $isPromotionEnabled.length > 0) {
          addStrikeClass = 'ph-strikeprice';
          pricesHtml = pricesHtml + ('<span class="ph-prodprice ' + addStrikeClass + '">' + priceRow.formattedValue + '</span>');

          var discRibbon = $(prodRow + product.code).find('.ph-discount-ribbon__text');

          discRibbon.html(ribbonText.replace('0', discVal));

          $(prodRow + product.code).find('.ph-discount-ribbon').show();
        } else if (priceRow.priceType === 'BUY' && priceRow.pricingConditionCode !== 'YLRR' && priceRow.value !== 0.0) {
          pricesHtml = pricesHtml + ('<span class="ph-prodprice ph-prodprice-pop ' + addStrikeClass + '">' + priceRow.formattedValue + '</span>');
        } else if (freeMarketingProductVal === 'true' && priceRow.pricingConditionCode === 'PNTP' && priceRow.value === 0.0) {
          pricesHtml = pricesHtml + ('<span class="ph-prodprice ph-prodprice-pop ' + addStrikeClass + '">' + freePriceText + '</span>');
        }

        if (priceRow.iconType === 'red') {
          $(prodRow + product.code).find('.ph-promotionicon__red').removeClass('ph-hide__icons');
          $(prodRow + product.code).find('.ph-promotionenddate').html(priceRow.promotionEndDate);
        } else if (priceRow.iconType === 'blue') {
          $(prodRow + product.code).find('.ph-promotionicon__blue').removeClass('ph-hide__icons');
          $(prodRow + product.code).find('.ph-pricedate').html(priceRow.promotionEndDate);
        }

        ACC.decisionPageInfiniteLoader.rrpPriceCallDec(result, index);
      }

      if ($('#product-detail-content-top').find('.text-part').length > 0) {
        $('#ph-prices').html(pricesHtml);
      } else {
        $(prodRow + product.code).find('.ph-prices-section').html(pricesHtml);
        $(prodRow + product.code).find('.addToCartButton').removeClass('hidden');
        $(prodRow + product.code).find('.ph-loader').addClass('hidden');
      }
    }
  }

  function loadProductPrice(prodCodes) {
    PHI.common.getPriceData(prodCodes, function(result) {
      if (Array.isArray(result) && result.length > 0) {
        for (var index = 0; index < result.length; index = index + 1) {
          loadProductCondition(result, index);
        }
      }
    });
  }

  function checkquantitystockdecision(mxStockprod, nobackorderprod, outofstockdisablebtn, prodcode) {
    $(prodcode).each(function() {
      var nb = nobackorderprod;

      if (($(this).find('.ph-avail-orange').is(':visible') && nb === 'true') || ($(this).find('.ph-avail-green').is(':visible') && nb === 'true')) {
        /* Commenting this event and moving it inside atp call
        $(this).find('.ph-pdpquantity').keyup(function() {
          var productQty = $(this).val(),
              productCode = $(this).attr('data-prdcode'),
              isBlocked = '',
              btnWrapStr = 'ph-cartbtn-wrapper';

          isBlocked = ACC.common.isBlockedProduct(productCode);

          if (!isBlocked) {
            if (parseInt(productQty, 10) > mxStockprod) {
              $(this).siblings('.ph-productLowStock_popupMsg').removeClass('hidden');
              $(this).siblings('.' + btnWrapStr).find('.addToCartButton').attr('disabled', 'disabled');
              $(this).siblings('.' + btnWrapStr).find('.ph-addToCartButton .ph-cart').addClass(outofstockdisablebtn);
            } else {
              $(this).siblings('.ph-productLowStock_popupMsg').addClass('hidden');
              $(this).siblings('.' + btnWrapStr).find('.addToCartButton').removeAttr('disabled');
              $(this).siblings('.' + btnWrapStr).find('.ph-addToCartButton .ph-cart').removeClass(outofstockdisablebtn);
            }
          }
        }); */
      }
    });
  }

  function loadPrdInStock($plRowEl) {
    var prdToDisplay = '',
        displayNone = 'ph-d-none';

    if ($('#ph-filter-Availability').prop('checked') === true) {
      prdToDisplay = $plRowEl.addClass('ph-filter-red').addClass(displayNone);
    } else {
      prdToDisplay = $plRowEl.addClass('ph-filter-red').removeClass(displayNone);
    }

    return prdToDisplay;
  }

  function allMaxQtyValidationCheck($prodRow) {
    var prodCode = String($prodRow.closest('.ph-decisionpage__item').data('product-code')),
        prodAtpData = PHI.common.checkIfAtpDataExists(prodCode),
        maxQtyData = getMaxQtyObjByCode(PRODUCT_MAX_QTY_DATA.productMaxQtyDatas, String(prodCode)),
        // eslint-disable-next-line no-ternary, no-undefined
        prodMaxQtyData = (maxQtyData !== undefined) && !(Array.isArray(maxQtyData) && maxQtyData.length === 0) ? maxQtyData[0] : '',
        noBackorderToggle = $('.ph-nobackorderprod').val(),
        maxQtyEnabled = $('#maxQuantityToggle').val(),
        dchainProdToggle = $('.ph-dchain-product-toggle').val(),
        dChainValue = $prodRow.find('.ph-dchainvalue').val(),
        dChainFirstEntry = ACC.common.getDChainFirstEntry(prodAtpData),
        // eslint-disable-next-line no-negated-condition, no-ternary
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line  compat/compat, no-negated-condition, no-ternary
        dChainFirstEntryQty = dChainFirstEntry !== null ? Object.values(dChainFirstEntry)[0] : '',
        enteredQty = $prodRow.closest('.ph-decisionpage__item').find('.plp_qtyinput').val(),
        lowestMaxQtyResult = '';

    /* eslint-disable no-ternary, no-undefined */
    var maxQtyReqParams = {
      nobackorderprod: noBackorderToggle,
      maxQtyEnabled: maxQtyEnabled,
      enteredQty: enteredQty,
      lowStockQty: prodAtpData.atpData.lowStockQty,
      maxQty: prodMaxQtyData.maxQtyToOrder === undefined ? -1 : prodMaxQtyData.maxQtyToOrder,
      totalOrdered: prodMaxQtyData.totalOrdered === undefined ? -1 : prodMaxQtyData.totalOrdered,
      isFreeMarketingProduct: prodMaxQtyData.isFreeMarketingMaterial === undefined ? false : prodMaxQtyData.isFreeMarketingMaterial,
      freeMarketingMaxQty: prodMaxQtyData.maxMarketingMatQtyToOrder === undefined ? -1 : prodMaxQtyData.maxMarketingMatQtyToOrder,
      dChainProductToggle: dchainProdToggle,
      dChainProductValue: dChainValue,
      dChainProductFirstEntryDate: dChainFirstEntryDate,
      dChainProductFirstEntryQty: dChainFirstEntryQty
    };
    /* eslint-enable no-ternary, no-undefined */

    lowestMaxQtyResult = ACC.common.checkAllMaxQtyValidation(maxQtyReqParams);

    $prodRow.find('.ph-productLowStock_popupMsg').addClass('hidden');
    $prodRow.find('.ph-productQuantity_popupMsg').addClass('hidden');
    $prodRow.find('.ph-productFreeMarketingMaxQty_popupMsg').addClass('hidden');
    $prodRow.find('.ph-productDChainMaxQty_popupMsg').addClass('hidden');
    $prodRow.find('.ph-cart').removeClass('ph-outofstockdisablebtn');

    if (lowestMaxQtyResult === 'lowStock') {
      showLowStockPopup($prodRow);

      var popupEl = $prodRow.find('.ph-productLowStock_popupMsg'),
          popupText = $prodRow.find('.ph-productLowStock_popupMsg').html();

      if (popupText.indexOf(' 0 ') >= 0) {
        popupEl.html(popupEl.html().replace('0', prodAtpData.atpData.lowStockQty));
      } else {
        var digits = popupText.match(/\d+/g);

        popupEl.html(popupEl.html().replace(digits, prodAtpData.atpData.lowStockQty));
      }
    } else if (lowestMaxQtyResult === 'maxQty') {
      showMaxQtyPopup($prodRow);
      evaluatePopupMsgQty(prodMaxQtyData.maxQtyToOrder - prodMaxQtyData.totalOrdered, $prodRow);
    } else if (lowestMaxQtyResult === 'freeMarketingMaxQty') {
      showFreeMarkMaxQtyPopup($prodRow, prodMaxQtyData.maxMarketingMatQtyToOrder);
    } else if (lowestMaxQtyResult === 'dChain50' || lowestMaxQtyResult === 'dChain30') {
      showDChainMaxQtyPopup($prodRow, dChainFirstEntryQty);
    }
  }

  function productMaxQtyCheckForDecisionPage(atpResult) {
    if (atpResult && PRODUCT_MAX_QTY_DATA.productMaxQtyDatas !== null && getMaxQtyObjByCode(PRODUCT_MAX_QTY_DATA.productMaxQtyDatas, atpResult.code).length > 0) {
      var maxQtyObj = getMaxQtyObjByCode(PRODUCT_MAX_QTY_DATA.productMaxQtyDatas, atpResult.code)[0],
          maxQty = maxQtyObj.maxQtyToOrder,
          freeMarktingMaxQty = maxQtyObj.maxMarketingMatQtyToOrder,
          freeMarktingProduct = maxQtyObj.isFreeMarketingMaterial,
          /* Commenting as it is not required
          lowStockQuantity = parseInt(atpResult.atpData.lowStockQty, 10), */
          totalOrdered = getMaxQtyObjByCode(PRODUCT_MAX_QTY_DATA.productMaxQtyDatas, atpResult.code)[0].totalOrdered,
          lowestMaxQty = maxQty,
          maxQtyEnabled = $('#maxQuantityToggle').val(),
          maxQtyEnabledAndDataAvail = maxQtyEnabled === 'true' && maxQty > 0,
          freeMarktingProdAndDataAvail = freeMarktingProduct && freeMarktingMaxQty > 0;

      var $currentItem = $('#ph-pl-row-' + atpResult.code);

      if ((freeMarktingProdAndDataAvail && maxQtyEnabledAndDataAvail && freeMarktingMaxQty < maxQty) || !maxQtyEnabledAndDataAvail) {
        lowestMaxQty = freeMarktingMaxQty;
      }

      if (maxQtyEnabledAndDataAvail || freeMarktingProdAndDataAvail) {
        $currentItem.find('#ph-item_maxQuantity_value').html(lowestMaxQty);
        // eslint-disable-next-line no-ternary
        $currentItem.find('#ph-item_orderedQuantity_value').html(totalOrdered === -1 ? 0 : totalOrdered);

        $currentItem.find('.ph-productMaxQty_totalOrdered').removeClass('hidden');
        $currentItem.find('.ph-productQuantity_popupMsg').addClass('hidden');

        if (getMaxQtyObjByCode(PRODUCT_MAX_QTY_DATA.productMaxQtyDatas, atpResult.code)[0].showError === true || maxQty === 0) {
          $currentItem.find('.ph-cart').addClass('ph-outofstockdisablebtn');
          $currentItem.find('.ph-addToCartButton').addClass('ph-outofstockdisablebtn').attr('disabled', 'disabled');
          showAnnualPopup($currentItem);
        }
        /* Commenting this block and moving it inside atp call
        else {
          $currentItem.find('.' + ACC.common.pdpQuantityCls).keyup(function() {
            var productQty = parseInt($(this).val(), 10);

            $currentItem.find('.ph-productLowStock_popupMsg').addClass('hidden');

            displayPopup($currentItem, maxQty, lowStockQuantity, productQty, totalOrdered, freeMarktingProduct, freeMarktingMaxQty);
          });
        } */
      }
    }
  }

  function loadAtpData(result) {
    var $plRowEl = $('#ph-pl-row-' + result.code),
        nobackorderprod = $('.ph-nobackorderprod').val(),
        outofstockdisablebtn = 'ph-outofstockdisablebtn',
        mxStockprod = result.atpData.maxStockQty,
        lowStockQty = result.atpData.lowStockQty,
        dChainProductToggle = $('.ph-dchain-product-toggle').val(),
        dChainProductValue = result.dchainValue,
        dChainProdValidFrom = result.validFrom,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(result),
        // eslint-disable-next-line no-negated-condition, no-ternary
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line no-negated-condition, no-ternary, compat/compat
        dChainFirstEntryQty = dChainFirstEntry !== null ? parseInt(Object.values(dChainFirstEntry)[0], 0) : '',
        $backordcountdec = $plRowEl.find('.ph-backordermaxcountdec'),
        existingtext = '',
        maxQtyEnabled = $('#maxQuantityToggle').val(),
        isFreeMarketingProduct = $plRowEl.find('.ph-freeMarketingProductCls').val();

    if (maxQtyEnabled === 'true' || isFreeMarketingProduct === 'true') {
      productMaxQtyCheckForDecisionPage(result);
    }

    if (result.atpData.availabilityCode === 'red') {
      loadPrdInStock($plRowEl);

      $plRowEl.find('.ph-avail-red').removeClass('hidden');
      ACC.decisionpage.backorderNotifyCheck($plRowEl);
    } else if (result.atpData.availabilityCode === 'green') {
      $plRowEl.addClass('ph-filter-green');
      $plRowEl.find('.ph-avail-green').removeClass('hidden');
      existingtext = $backordcountdec.text();
      $backordcountdec.text(existingtext.replace('0', result.atpData.maxStockQty));

      // eslint-disable-next-line no-undefined
      if (getMaxQtyObjByCode(PRODUCT_MAX_QTY_DATA.productMaxQtyDatas, result.code) === undefined) {
        checkquantitystockdecision(mxStockprod, nobackorderprod, outofstockdisablebtn, $plRowEl);
      }
    }

    if (result.atpData.availabilityCode === 'orange') {
      $plRowEl.addClass('ph-filter-green');
      $plRowEl.find('.ph-availCount').html(result.atpData.lowStockQty);
      $plRowEl.find('.ph-avail-orange').removeClass('hidden');
      existingtext = $backordcountdec.text();
      $backordcountdec.text(existingtext.replace('0', result.atpData.maxStockQty));

      // eslint-disable-next-line no-undefined
      if (getMaxQtyObjByCode(PRODUCT_MAX_QTY_DATA.productMaxQtyDatas, result.code) === undefined) {
        // eslint-disable-next-line no-ternary
        checkquantitystockdecision(mxStockprod === 0 ? lowStockQty : mxStockprod, nobackorderprod, outofstockdisablebtn, $plRowEl);
      }
    }

    /* Dchain implementation start */

    if (dChainProductToggle === 'true' && dChainProductValue !== '' && dChainProductValue !== null) {
      if (dChainProductValue === '30') {
        if ((nobackorderprod === 'false' &&
          ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate)) ||
          ((nobackorderprod === 'true') &&
          (result.atpData.availabilityCode === 'green' || result.atpData.availabilityCode === 'orange') &&
          ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
        ) {
          $plRowEl.find('.ph-cart').removeClass('ph-outofstockdisablebtn');
          $plRowEl.find('.addToCartButton').prop('disabled', false).removeAttr('disabled');
        } else if ((nobackorderprod === 'true' && result.atpData.availabilityCode === 'red') ||
          !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
        ) {
          $plRowEl.find('.ph-cart').addClass('ph-outofstockdisablebtn');
          $plRowEl.find('.addToCartButton').prop('disabled', true).attr('disabled', 'disabled');

          // Hiding Deal Ribbon when product is dchain conditions are met
          $plRowEl.find('.ph-available-deals-container').addClass('ph-d-none');

          if ((result.atpData.availabilityCode === 'green' || result.atpData.availabilityCode === 'orange') &&
            !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))) {
            $plRowEl.find('.ph-avail-status > span').addClass('hidden');

            if (result.atpData.availabilityCode === 'green') {
              $plRowEl.find('.ph-avail-status .ph-avail-30-future-instock').removeClass('hidden');
            } else if (result.atpData.availabilityCode === 'orange') {
              $plRowEl.find('.ph-avail-status .ph-avail-30-future-lowstock').removeClass('hidden');
            }
          }
        }
      } else if (dChainProductValue === '50') {
        if ((result.atpData.availabilityCode === 'red') || (!ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate) && (dChainFirstEntryQty === '' || dChainFirstEntryQty <= 0))) {
          $plRowEl.find('.ph-cart').addClass('ph-outofstockdisablebtn');
          $plRowEl.find('.addToCartButton').prop('disabled', true).attr('disabled', 'disabled');
          $plRowEl.find('.ph-avail-status > span').addClass('hidden');
          $plRowEl.find('.ph-avail-status > .ph-avail-50-nostock').removeClass('hidden');

          // Hiding Deal Ribbon when product is dchain conditions are met
          $plRowEl.find('.ph-available-deals-container').addClass('ph-d-none');
        }
      }
    }

    /* Dchain implementation end */

    if (!$plRowEl.find('.ph-cart').hasClass('ph-outofstockdisablebtn')) {
      $($plRowEl).on('keyup', '.plp_qtyinput', function() {
        allMaxQtyValidationCheck($(this).closest('.ph-decisionpage__item'));
      });
    }

    ACC.common.checkForBlockedProducts(result.code);
    $plRowEl.find('.addToCartButton').removeClass('hidden');
    $plRowEl.find('.ph-loader').addClass('hidden');
  }

  /* eslint-disable consistent-return */
  function getMaxQtyObjByCode(maxQtyResult, prodCode) {
    if (maxQtyResult && prodCode) {
      return maxQtyResult.filter(function(obj) {
        return obj.productCode === prodCode;
      });
    }
  }
  /* eslint-enable consistent-return */

  function evaluatePopupMsgQty(qty, currentItem) {
    var $popupEl = currentItem.find('.ph-productQuantity_popupMsg'),
        popupText = currentItem.find('.ph-productQuantity_popupMsg').html();

    if (popupText.indexOf('{0}') >= 0) {
      $popupEl.html($popupEl.html().replace('{0}', qty));
    } else {
      var digits = popupText.match(/\d+/g);

      $popupEl.html($popupEl.html().replace(digits, qty));
    }
  }

  function showMaxQtyPopup(currentItem) {
    currentItem.find('.ph-productQuantity_popupMsg').removeClass('hidden');
    currentItem.find('.ph-cart').addClass('ph-outofstockdisablebtn');
  }

  function showLowStockPopup(currentItem) {
    currentItem.find('.ph-productLowStock_popupMsg').removeClass('hidden');
    currentItem.find('.ph-cart').addClass('ph-outofstockdisablebtn');
  }

  function showFreeMarkMaxQtyPopup(currentItem, freeMarktingMaxQty) {
    currentItem.find('.ph-productFreeMarketingMaxQty_popupMsg').removeClass('hidden').find('.ph-free-max-qty-value').text(freeMarktingMaxQty);
    currentItem.find('.ph-cart').addClass('ph-outofstockdisablebtn');
  }

  // eslint-disable-next-line id-match
  function showDChainMaxQtyPopup(currentItem, dChainMaxQty) {
    currentItem.find('.ph-productDChainMaxQty_popupMsg').removeClass('hidden').find('.ph-dcahin-max-qty-value').text(dChainMaxQty);
    currentItem.find('.ph-cart').addClass('ph-outofstockdisablebtn');
  }

  /* Commenting below function as max quanity check if implemented in different function
  function displayPopup(currentItem, maxQty, lowStockQuantity, productQty, totalOrdered, freeMarktingProduct, freeMarktingMaxQty) {
    var nobackorderprod = $('.ph-nobackorderprod').val(),
        maxQtyEnabled = $('#maxQuantityToggle').val(),
        maxQtyText = '';

    currentItem.find('.ph-productQuantity_popupMsg').addClass('hidden');
    currentItem.find('.ph-productFreeMarketingMaxQty_popupMsg').addClass('hidden');
    currentItem.find('.ph-cart').removeClass('ph-outofstockdisablebtn');

    maxQtyText = ACC.common.getLowestMaxQtyValue(nobackorderprod === 'true', maxQtyEnabled === 'true', productQty, lowStockQuantity, maxQty, totalOrdered, freeMarktingProduct, freeMarktingMaxQty);

    if (maxQtyText === 'lowStock') {
      showLowStockPopup(currentItem);

      var popupEl = currentItem.find('.ph-productLowStock_popupMsg'),
          popupText = currentItem.find('.ph-productLowStock_popupMsg').html();

      if (popupText.indexOf(' 0 ') >= 0) {
        popupEl.html(popupEl.html().replace('0', lowStockQuantity));
      } else {
        var digits = popupText.match(/\d+/g);

        popupEl.html(popupEl.html().replace(digits, lowStockQuantity));
      }
    } else if (maxQtyText === 'maxQty') {
      showMaxQtyPopup(currentItem);
      evaluatePopupMsgQty(maxQty - totalOrdered, currentItem);
    } else if (maxQtyText === 'freeMarketingMaxQty') {
      showFreeMarkMaxQtyPopup(currentItem, freeMarktingMaxQty);
    }
  } */

  function showAnnualPopup(currentItem) {
    currentItem.find('.ph-cartbtn-wrapper').on('mouseenter', function() {
      currentItem.find('.ph-addToCart_AnnualPopupMsg').removeClass('hidden');
    });
    currentItem.find('.ph-cartbtn-wrapper').on('mouseleave', function() {
      currentItem.find('.ph-addToCart_AnnualPopupMsg').addClass('hidden');
    });
  }

  function initProductAtpCall(prodCodes) {
    for (var prdIdx = 0; prdIdx < prodCodes.length; prdIdx = prdIdx + 1) {
      ACC.common.getAtpData(prodCodes[prdIdx], function(result) {
        if (result) {
          loadAtpData(result);
        }
      });
    }
  }

  // eslint-disable-next-line id-match, init-declarations
  var PRODUCT_MAX_QTY_DATA;

  function loadProductAvilability(prodCodes, maxQtyProductCodeList) {
    if (maxQtyProductCodeList.length > 0) {
      PHI.common.getMaxQuantity(maxQtyProductCodeList, function(maxQtyResult) {
        PRODUCT_MAX_QTY_DATA = maxQtyResult;

        initProductAtpCall(prodCodes);
      });
    } else {
      initProductAtpCall(prodCodes);
    }
  }

  function categoryPageJsonPath(pageLengths) {
    var categoryJsonUrl = '',
        basepath = window.location.protocol + '//' + window.location.host,
        relativePath = window.location.href.replace(basepath, '');

    if (relativePath.indexOf('/c/')) {
      var relativePathSplitted = relativePath.split('/c/');
      var categoryUrl = String(relativePathSplitted[0] + '/c/');
      var categoryName = String(relativePathSplitted[1]);

      if (categoryName.indexOf('?')) {
        categoryName = categoryName.split('?')[0];
      }

      if (categoryName.indexOf('#')) {
        categoryName = categoryName.split('#')[0];
      }

      var queryString = $('.ph-querystringvalue').val();
      var sortValue = $('#sortOptions2').val();

      categoryJsonUrl = categoryUrl + 'getProductsList?categoryCode=' + categoryName + '&page=' + pageLengths + '&q=' + queryString + '&sort=' + sortValue + '&show=Page';
    }

    return categoryJsonUrl;
  }

  // eslint-disable-next-line id-match
  function selectJsonURL(pageLengths) {
    var jsonUrlSelected = '',
        basepath = window.location.protocol + '//' + window.location.host,
        relativePath = window.location.href.replace(basepath, '');

    var relativePathSplitted = relativePath.split('?')[0];

    if ($('.ph-searchresultpage').length > 0) {
      var queryString = $('.ph-querystringvalue').val();
      var sortValue = $('#sortOptions2').val();

      /* Commenting to change the existing search api call
      jsonUrlSelected = basepath + relativePathSplitted + '/getSearchResults.json?page=' + pageLengths + '&q=' + queryString + '&sort=' + sortValue + '&show=Page'; */

      jsonUrlSelected = basepath + relativePathSplitted + '/getProductSearchResults?page=' + pageLengths + '&q=' + queryString + '&sort=' + sortValue + '&show=Page';
    } else {
      jsonUrlSelected = categoryPageJsonPath(pageLengths);
    }

    return jsonUrlSelected;
  }

  function loadContentSmartly(container, observer) {
    var tpages = 'totalpages-available',
        decpageItem = 'decisionpage__item',
        pageLength = $('.ph-decisionpage__cards').find('.ph-' + decpageItem).length / parseInt($('.decisionpage_items_perpage').val(), 10),
        numberOfPages = parseInt($('.ph-itemsshown').attr('data-pagenumber'), 10),
        pageLengths = Math.ceil(pageLength),
        initiated = parseInt($('.' + tpages).attr('data-initiated'), 10),
        notifymeBtn = 'notifyme-button',
        $intObs = $('.ph-intersection-observer'),
        addtocartButton = 'addtocartButton',
        disableButton = 'ph-disable-button',
        cartDisable = 'ph-cart-disable';

    if (initiated < pageLengths) {
      $('.' + tpages).attr('data-initiated', pageLengths);
      $.ajax({
        url: selectJsonURL(pageLengths),
        dataType: 'html',
        async: false,
        success: function(response) {
          /* Commenting this as lazy loading is rendering from jsp instead of javascript
          response.results.map(ACC.decisionPageInfiniteLoader.processTemplating); */

          ACC.decisionPageInfiniteLoader.filterPromotionMsg();

          // Price call changes
          var prodCodes = [],
              isAtpAvailable = $('.ph-atp-enabled').length > 0,
              maxQtyProductCodeList = [],
              isPricingCallEnabled = $('.ph-enablepricingcall').length > 0,
              priceSecVar = 'ph-prices-section',
              maxQtyEnabled = $('#maxQuantityToggle').val();

          if ($(response).filter('.ph-decisionpage__item').length > 0) {
            $('#decisionpageCards').append(response);
          }

          $(response).filter('.ph-decisionpage__item').each(function(index, item) {
            var prodCode = $(item).attr('id').split('ph-pl-row-'),
                $currentDecisionItem = $('#ph-pl-row-' + prodCode[1]),
                isFreeMarketingProduct = $(item).find('.ph-freeMarketingProductCls').val();

            if (prodCode) {
              if (maxQtyEnabled === 'true' || isFreeMarketingProduct === 'true') {
                maxQtyProductCodeList.push(prodCode[1]);
              }

              prodCodes.push(prodCode[1]);
            }

            if (isPricingCallEnabled === true) {
              $currentDecisionItem.find('.' + priceSecVar).show();
            } else {
              $currentDecisionItem.find('.' + priceSecVar).hide();
            }

            if ($('.page-productDetails').length === 0) {
              $currentDecisionItem.find('.add_to_cart_form').show();
              $currentDecisionItem.find('.ph-loader').removeClass('hidden');
            }

            $currentDecisionItem.find('.ph-ratingAndreview').each(function() {
              if ($(this).attr('data-url') !== '' && $(this).attr('data-url') !== 'null') {
                $(this).css('cursor', 'pointer');
                $(this).on('click', function() {
                  var ratingUrl = $(this).attr('data-url'),
                      ratingNumber = $(this).attr('data-rating');

                  if (ratingNumber > 0) {
                    ACC.common.showRatingsConfirmationPopup(ratingUrl);
                  }
                });
              } else {
                $(this).css('cursor', 'default');
              }
            });
          });

          if (prodCodes.length > 0) {
            if (isPricingCallEnabled === true) {
              loadProductPrice(prodCodes);
            }

            if (isAtpAvailable === true) {
              loadProductAvilability(prodCodes, maxQtyProductCodeList);
            }

            ACC.decisionPageInfiniteLoader.toggleProductListView();
          }

          if (prodCodes.length !== 0 && $('.ph-sap-orderBlock').length > 0) {
            $('.' + addtocartButton).addClass(disableButton).attr('disabled', 'disabled');
            $('.ph-cart').addClass(cartDisable);
            $('.ph-' + notifymeBtn).addClass(disableButton);
          }
        },

        error: function(a, b, c) {
          // eslint-disable-next-line no-console
          console.log(a + b + c);
        }
      });
    } else {
      $intObs.hide();
    }

    observer.unobserve(container);

    if (pageLengths >= numberOfPages) {
      $intObs.remove();
      setTimeout(function() {
        ACC.decisionPageInfiniteLoader.isProductCardEmpty();
      }, 200);
    }
  }

  function setObserver() {
    var container = document.querySelector('.ph-intersection-observer');

    function intersection() {
      /* eslint-disable compat/compat */
      var observer = new IntersectionObserver(function(entries) {
        /* eslint-enable compat/compat */
        entries.map(function(entry) {
          var isIntersecting = entry.isIntersecting;

          if (isIntersecting) {
            loadContentSmartly(container, observer);
            observer.observe(container);
          }

          return true;
        }, {
          root: null,
          rootMargin: '0px',
          threshold: 0
        });
      });

      observer.observe(container);
    }

    if ('IntersectionObserver' in window) {
      intersection();
    } else {
      $.getScript(ACC.config.commonResourcePath + '/js/vendor/intersection-observer.min.js', function() {
        intersection();
      });
    }
  }

  // DEC first 9 products functions
  $(document).ready(function() {
    var isPricingCallEnabled = $('.ph-enablepricingcall').length > 0;
    var isAtpAvailable = $('.ph-atp-enabled').length > 0,
        categoryCode = $('.ph-headerparent__categorycode').val(),
        disableButton = 'ph-disable-button';

    if ($('.page-productDetails').length === 0) {
      if (isPricingCallEnabled === true || isAtpAvailable === true) {
        var prodCodes = [],
            initialLoadAllProductList = [];

        $('.addToCartButton').addClass('hidden');
        $('.ph-loader').removeClass('hidden');

        if (categoryCode === 'PromotionalCategory') {
          $('#ph-filter-Availability').prop('checked', true);

          $('.ph-intersection-observer').hide();
          $('.ph-instock-loader').removeClass('hidden');
        }

        $('.ph-decisionpage__item').each(function(index, item) {
          var prodCode = $(item).attr('id').split('ph-pl-row-');

          if (prodCode) {
            initialLoadAllProductList.push(prodCode[1]);
            prodCodes.push(prodCode[1]);
          }
        });

        var priceSecVar = 'ph-prices-section';

        if (prodCodes.length > 0 && (isPricingCallEnabled === true)) {
          $('.' + priceSecVar).show();
          loadProductPrice(initialLoadAllProductList);
        } else {
          $('.' + priceSecVar).hide();
        }

        if (prodCodes.length > 0 && isAtpAvailable === true) {
          loadProductAvilability(prodCodes, initialLoadAllProductList);
        }
      }
    }

    ACC.decisionPageInfiniteLoader.filterPromotionMsg();

    if ($('#decisionpageCards .ph-decisionpage__item').length > 0) {
      $('.ph-productsempty-msg').addClass('hidden');
    }

    if ($('.ph-sap-orderBlock').length > 0) {
      $('.ph-addToCartButton').addClass(disableButton).attr('disabled', 'disabled');
      $('.ph-notifyme-button').addClass(disableButton);
      $('.ph-cart').addClass('ph-cart-disable');
    }

    if ($('.ph-decisionpage__cards').length > 0) {
      setObserver();
    }
  });

  $(function() {
    $('.filter').selectBox();
  });

  $(function() {
    $('.ph-header_b2bunitname').selectBox();
  });
})();

$(document).ready(function() {
  var $eqPopup = $('.ph-quantity_details_modal'),
      qtySave = 'qtydet__block__action--save',
      dChainToggle = $('.ph-dchain-product-toggle').val(),
      maxQtyEnabled = $('#ph-maxQuantityToggleEnabled').val();

  $(document).on('click', '.ph-qtydet__block__action--cancel', function() {
    $('.ph-' + qtySave).removeClass('ph-disable_apply_button');
    $eqPopup.addClass('hidden');
    $.colorbox.close();
  });

  $(document).on('blur', '.qty', function() {
    var entryNum = $(this).val();

    $(this).next().val(entryNum);
  });

  function showLowStockQtyPopup(lowStockQuantity) {
    $('#cboxContent .ph-maxStockQtyPopup').removeClass('hidden');
    $('#cboxContent .ph-qtydet__block__action--save').addClass('ph-disable_apply_button');
    $('#cboxContent .ph-maxStockQtyPopup').html($('.ph-maxStockQtyPopup').html().replace('{0}', lowStockQuantity));
  }

  function showMaxQtyErrorPopup(maxQty, totalOrdered) {
    $('#cboxContent .ph-productMaxQty_popupMsgError').removeClass('hidden');
    $('#cboxContent .ph-qtydet__block__action--save').addClass('ph-disable_cart_max_qty');
    $('#cboxContent .ph-productMaxQty_popupMsgError').html($('.ph-productMaxQty_popupMsgError').html().replace('{0}', maxQty - totalOrdered));
  }

  function showFreeMarkettingProductPopup(maxMarketingMatQtyToOrder) {
    $('#cboxContent .ph-free-marketing-max-qty-popup').removeClass('hidden');
    $('#cboxContent .ph-pdp-cartbtn-wrapper').find('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
    $('#cboxContent .ph-free-marketing-max-qty-popup').find('.ph-free-max-qty-value').text(maxMarketingMatQtyToOrder);
    $('#cboxContent .ph-qtydet__block__action--save').addClass('ph-disable_cart_max_qty');
  }

  function showDchainMaxQtyPopup(dChainMaxQty) {
    $('#cboxContent .ph-dchain-max-qty-popup').removeClass('hidden');
    $('#cboxContent .ph-pdp-cartbtn-wrapper').find('.ph-pdp_addtocart_button').addClass('ph-outofstockdisablebtn');
    $('#cboxContent .ph-dchain-max-qty-popup').find('.ph-dchain-qty-value').text(dChainMaxQty);
    $('#cboxContent .ph-qtydet__block__action--save').addClass('ph-disable_cart_max_qty');
  }

  function loadCartPageAtpData(atpResult) {
    var productCode = atpResult.code,
        $prodRow = $('.ph-cartrow-' + productCode),
        availStatus = atpResult.atpData.availabilityCode,
        listbackordertoggle = $('#nobackorderset').val(),
        dChainProductToggle = $('.ph-dchain-product-toggle').val(),
        isFreeMarketingdProduct = atpResult.isFreeMarketingProduct,
        dChainProductValue = atpResult.dchainValue,
        dChainProdValidFrom = atpResult.validFrom,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(atpResult),
        // eslint-disable-next-line no-negated-condition, no-ternary
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line no-negated-condition, no-ternary, compat/compat
        dChainFirstEntryQty = dChainFirstEntry !== null ? parseInt(Object.values(dChainFirstEntry)[0], 0) : '',
        checkoutBtnDisabled = false,
        productQuantity = parseInt($prodRow.parent().find('.ph-Eqpopup_qty').val(), 0);

    /* Dchain implementation start */

    if (dChainProductToggle === 'true' && dChainProductValue !== '' && dChainProductValue !== null) {
      if (dChainProductValue === '30') {
        if ((listbackordertoggle === 'true' && availStatus === 'red') ||
          !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))
        ) {
          $prodRow.find('.ph-dchain-out-of-stock-msg').removeClass('ph-d-none');

          if ((availStatus === 'green' || availStatus === 'orange') &&
            !(ACC.common.checkDChainDateIslessThanToday(dChainProdValidFrom) && ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate))) {
            // eslint-disable-next-line max-depth
            if (availStatus === 'green') {
              $prodRow.find('.error-message').addClass('ph-d-none');
              $prodRow.find('.ph-dchain-30-future-instock').removeClass('ph-d-none');
            } else if (availStatus === 'orange') {
              $prodRow.find('.error-message').addClass('ph-d-none');
              $prodRow.find('.ph-dchain-30-future-lowstock').removeClass('ph-d-none');
            }
          }
        }
      } else if (dChainProductValue === '50') {
        if ((availStatus === 'red') || (!ACC.common.checkDChainDateIslessThanToday(dChainFirstEntryDate) && (dChainFirstEntryQty === '' || dChainFirstEntryQty <= 0))) {
          $prodRow.find('.error-message').addClass('ph-d-none');
          $prodRow.find('.ph-dchain-50-nostock').removeClass('ph-d-none');
        }
      }

      /* Check dchain quantity start*/

      if (listbackordertoggle === 'true' && availStatus !== 'red') {
        if (dChainFirstEntryQty !== null && productQuantity > dChainFirstEntryQty) {
          $prodRow.find('.error-message').addClass('ph-d-none');
          $prodRow.find('.ph-dchain-low-stock-msg').removeClass('ph-d-none').find('.ph-dchain-low-qty-value').text(dChainFirstEntryQty);
        }
      }

      /* Check dchain quantity end*/
    }
    /* Dchain implementation end */

    checkoutBtnDisabled = $('.ph-checkout-btn').hasClass('ph-disable-button');

    if (!checkoutBtnDisabled &&
    ($('.ph-dchain-out-of-stock-msg.ph-d-none').length === $('.ph-dchain-out-of-stock-msg').length) &&
    ($('.ph-dchain-low-stock-msg.ph-d-none').length === $('.ph-dchain-low-stock-msg').length) &&
    ($('.ph-dchain-50-nostock.ph-d-none').length === $('.ph-dchain-50-nostock').length) &&
    ($('.ph-dchain-30-future-lowstock.ph-d-none').length === $('.ph-dchain-30-future-lowstock').length) &&
    ($('.ph-dchain-30-future-instock.ph-d-none').length === $('.ph-dchain-30-future-instock').length)) {
      $('.ph-checkout-btn').removeClass('ph-disable-button');
    } else {
      $('.ph-checkout-btn').addClass('ph-disable-button');
    }

    if (maxQtyEnabled === 'true' || isFreeMarketingdProduct) {
      // eslint-disable-next-line no-unused-vars, no-empty-function
      PHI.common.getMaxQuantity(productCode, function(maxQtyResult) {});
    }
  }

  function checkAllMaxQtyCondInCartPage(prodCode) {
    /* eslint-disable no-ternary, no-undefined */
    var productQty = parseInt($('#cboxContent .ph-Eqpopup_qty').val(), 10),
        existtext = $('.ph-backordermaxcount').html(),
        atpDataResult = ACC.common.getAtpDataFromGlobalVar(prodCode),
        maxQtyResult = ACC.common.getMaxQtyDataFromGlobalVar(prodCode),
        lowStockQuantity = atpDataResult.atpData.lowStockQty,
        prodMaxQtyData = maxQtyResult,
        noBackorderToggle = $('#nobackorderset').val(),
        maxQtyEnabledToggle = $('#ph-maxQuantityToggleEnabled').val(),
        dchainProdToggle = $('.ph-dchain-product-toggle').val(),
        lowStockQty = atpDataResult.atpData.lowStockQty,
        maxQty = prodMaxQtyData.maxQtyToOrder === undefined ? -1 : prodMaxQtyData.maxQtyToOrder,
        totalOrdered = prodMaxQtyData.totalOrdered === undefined ? -1 : prodMaxQtyData.totalOrdered,
        freeMarketingProductMaxQty = prodMaxQtyData.maxMarketingMatQtyToOrder === undefined ? -1 : prodMaxQtyData.maxMarketingMatQtyToOrder,
        dChainValue = atpDataResult.dchainValue,
        dChainFirstEntry = ACC.common.getDChainFirstEntry(atpDataResult),
        // eslint-disable-next-line no-negated-condition
        dChainFirstEntryDate = dChainFirstEntry !== null ? Object.keys(dChainFirstEntry)[0] : '',
        // eslint-disable-next-line  compat/compat, no-negated-condition
        dChainFirstEntryQty = dChainFirstEntry !== null ? Object.values(dChainFirstEntry)[0] : '',
        maxQtyText = '';

    var maxQtyReqParams = {
      nobackorderprod: noBackorderToggle,
      maxQtyEnabled: maxQtyEnabledToggle,
      enteredQty: productQty,
      lowStockQty: lowStockQty,
      maxQty: prodMaxQtyData.maxQtyToOrder === undefined ? -1 : prodMaxQtyData.maxQtyToOrder,
      totalOrdered: prodMaxQtyData.totalOrdered === undefined ? -1 : prodMaxQtyData.totalOrdered,
      isFreeMarketingProduct: prodMaxQtyData.isFreeMarketingMaterial === undefined ? false : prodMaxQtyData.isFreeMarketingMaterial,
      freeMarketingMaxQty: prodMaxQtyData.maxMarketingMatQtyToOrder === undefined ? -1 : prodMaxQtyData.maxMarketingMatQtyToOrder,
      dChainProductToggle: dchainProdToggle,
      dChainProductValue: dChainValue,
      dChainProductFirstEntryDate: dChainFirstEntryDate,
      dChainProductFirstEntryQty: dChainFirstEntryQty
    };
    /* eslint-enable no-ternary, no-undefined */

    $('#cboxLoadedContent').find('.ph-backordermaxcount').text(existtext.replace('0', atpDataResult.atpData.maxStockQty));

    $('#cboxContent .ph-productMaxQty_popupMsgError').addClass('hidden');
    $('#cboxContent .ph-free-marketing-max-qty-popup').addClass('hidden');
    $('#cboxContent .ph-dchain-max-qty-popup').addClass('hidden');
    $('#cboxContent .ph-qtydet__block__action--save').removeClass('ph-disable_cart_max_qty');

    maxQtyText = ACC.common.checkAllMaxQtyValidation(maxQtyReqParams);

    if (maxQtyText === 'lowStock') {
      showLowStockQtyPopup(lowStockQuantity);
    } else if (maxQtyText === 'maxQty') {
      showMaxQtyErrorPopup(maxQty, totalOrdered);
    } else if (maxQtyText === 'freeMarketingMaxQty') {
      showFreeMarkettingProductPopup(freeMarketingProductMaxQty);
    } else if (maxQtyText === 'dChain50' || maxQtyText === 'dChain30') {
      showDchainMaxQtyPopup(dChainFirstEntryQty);
    }
  }

  $(document).on('keyup', '#cboxContent .ph-Eqpopup_qty', function() {
    PHI.common.getAtpData($('#cboxContent #ph-currentProductCode').val(), function(result) {
      var isFreeMarketingdProduct = result.isFreeMarketingProduct;

      if (maxQtyEnabled === 'true' || isFreeMarketingdProduct) {
        // eslint-disable-next-line no-unused-vars
        PHI.common.getMaxQuantity(result.code, function(maxQtyResult) {
          checkAllMaxQtyCondInCartPage(result.code);
        });
      } else {
        checkAllMaxQtyCondInCartPage(result.code);
      }
    });
  });

  $(document).on('click', '.ph-qtydet__block__action--save', function() {
    var prodsaveid = $(this).attr('id').split('_'),
        produid = prodsaveid[1],
        $form = $('#updateCartForm' + produid),
        method = '',
        newCartQuantity = $(this).parent().siblings().find('#ph-updatedqty_' + produid).val(),
        updatedQuantity = $('#ph-updatedqty_' + produid).val(),
        pointEvent = 'pointer-events',
        qtyActioncancel = 'qtydet__block__action--cancel',
        qtyActionSave = 'qtydet__block__action--save';

    $('#quantity' + produid).val(newCartQuantity);

    $('.ph-' + qtyActioncancel).addClass('hidden');
    $('.ph-cart_loader').removeClass('hidden');
    $('.ph-' + qtyActionSave).css(pointEvent, 'none');

    if ($form.attr('method')) {
      method = $form.attr('method').toUpperCase();
    } else {
      method = 'GET';
    }

    $.ajax({
      url: $form.attr('action'),
      data: $form.serialize(),
      type: method,
      success: function() {
        $('#quantity' + produid).val(updatedQuantity);
        window.location.reload(true);
      },
      error: function() {
        $('.ph-label').val('');
      }

    });
  });


  $('.ph-edit_productquantity').click(function() {
    /*  Fix for unique ids*/
    var prodidcode = $(this).attr('id').split('_');
    var productid = prodidcode[1];
    var prodQty = $('#quantity' + productid).val();
    var maxWidth = '742px';
    var unit = 'Piece';

    if (!$(this).hasClass('zoomqty_noedit')) {
      $('#prodCodeVal').val($('#prodCode_' + productid).val());
      $('#prodQuantityVal').val(prodQty);
      $('#prodIdVal').val(productid);
      $('#prodCountAmt' + productid).html(prodQty + ' &times ' + $('#product-unit-price-' + productid).text());
      $('#prodTotalAmt' + productid).html($('#prodTotalPrice_' + productid).text());
      $eqPopup.removeClass('hidden');
      $('.ph-pkgunit').html(' ' + unit);

      if ($(window).width() < 450) {
        maxWidth = '90%';
      }

      $.colorbox({
        width: '100%',
        scrolling: false,
        maxWidth: maxWidth,
        html: $('#ph-edit_quantity_popup_' + productid).html(),
        close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
        onComplete: function() {
          $eqPopup.addClass('hidden');
        },
        onClosed: function() {
          ACC.common.refreshScreenReaderBuffer();
        }
      });
    }
  });

  /* Moving below event function from pho.profile.js file as it is used in cart page only */
  $('.ph-edit_productquantity').click(function() {
    $('#cboxLoadedContent').find('.ph-Eqpopup_qty').trigger('keyup');
  });

  if ($('#ph-pageType').val() === 'cartPage') {
    if (dChainToggle === 'true') {
      $('.ph-totals-container .ph-prodcode').each(function() {
        var prodCode = $(this).val();

        PHI.common.getAtpData(prodCode, function(result) {
          loadCartPageAtpData(result);
        });
      });
    }
  }
});

/* Commenting as popup position is fixed dynamically from JS
$(window).on('load', function() {
  if ($('.warning').length > 0) {
    $('.ph-myaccountitemdiscount').addClass('ph-extrabottom');
  }
});
*/
$(document).ready(function() {
  var singleCheck = 'single__checkout',
      checkDatepick = 'checkout__datepicker',
      singCheckVal = 'single__checkout__value',
      $singleCheckout = $('.ph-' + singleCheck),
      $singleCheckoutDate = $('.ph-single__checkout_date'),
      $checkoutDatePicker = $('.phi-' + checkDatepick),
      currentDate = $('.ph-' + singCheckVal).html(),
      dateError = 'ph-date__error',
      requestDisable = 'ph-request__disable',
      deliverError = '<div class="ph-row ph-ml-0 ',
      reqDate = $('#representante_legal').val(),
      storeDate = '.ph-storeDate-',
      disableScroll = 'html, body',
      spinnerlargemultiple = 'spinnerlargemultiple',
      multidelItem = 'ph-multidel-item',
      checkoutDatePicker = 'phi-checkout__datepicker',
      spinnerlargesingle = 'spinnerlargesingle',
      poNumberCheckMandatory = $('#ph-emptyPoNumber').val();

  function hideDatepickerSpinner() {
    $('.ph-' + spinnerlargemultiple).addClass('hidden');
    $('.ph-' + spinnerlargesingle).addClass('hidden');
  }

  function showDatepickerSpinner() {
    $('.ph-' + spinnerlargemultiple).removeClass('hidden');
    $('.ph-' + spinnerlargesingle).removeClass('hidden');
  }

  function updateEntryDate(entryNumber, date, dpId, reqDateAll) {
    var prevrdd = 'data-prev-rdd',
        ajaxvanish = 'vanish-ajax',
        sapermsg = 'sapaddresserror';

    $('.ph-' + ajaxvanish).empty();
    $('.ph-' + sapermsg).empty();
    $.ajax({
      url: ACC.config.encodedContextPath + '/checkout/single/updateEntryDate',
      data: {
        entryNumber: entryNumber,
        reqDate: date,
        productCode: dpId,
        requestDeliveryDateForAll: reqDateAll
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        hideDatepickerSpinner();

        var scheduleData = '';
        var weCanDeliver = $('#ph-wecandeliver').val();
        var confirmedDelivery = $('#ph-confirmed').val();
        var parConfirmedDelivery = $('#ph-parconfirmed').val();
        var unConfirmedDelivery = $('#ph-unconfirmed').val();
        var blueMsg = 'ph-blue-msg';
        var orangeMsg = 'ph-orange-msg';

        for (var j = 0; j < result.entries.length; j = j + 1) {
          var prodCodeText = '#ph-wecandeliver-' + result.entries[j].productEntered;
          var prodOldsapdate = '.ph-sapdate-' + result.entries[j].productEntered;
          var proddefaultdelivertext = '.ph-defaultdelivertext-' + result.entries[j].productEntered;
          var $confirmationStatus = $('#ph-multiple-del' + result.entries[j].productEntered + ' .ph-confirmationstatus');

          if (reqDateAll === 'true' || parseInt(entryNumber, 10) === result.entries[j].entryNumber) {
            var scheduledatacontent = '';

            for (var schedIndex = 0; schedIndex < result.entries[j].scheduleLines.length; schedIndex = schedIndex + 1) {
              $(prodOldsapdate).remove();
              $(prodCodeText).find('.ph-multipleschlines').remove();
              $(prodCodeText).find('.ph-dynamictext').remove();
              $(proddefaultdelivertext).remove();
              scheduledatacontent = scheduledatacontent + '<div class="ph-updateddnamicvalue" id="ph-updateddnamicvalue-' +
                result.entries[j].productEntered + '">';


              scheduleData = result.entries[j].scheduleLines[schedIndex].formattedValue;
              scheduledatacontent = scheduledatacontent + '<div class="ph-dynamictext ph-float-left">' + weCanDeliver +
                '</div> <div class="ph-multiple__checkout__date ph-multipleschlines ph-float-left">' + scheduleData + '</div></div>';
            }

            $(prodCodeText).append(scheduledatacontent);


            if (result.entries[j].itemConfirmationStatus === 'C') {
              $confirmationStatus.html(confirmedDelivery);
              $confirmationStatus.removeClass(orangeMsg).addClass(blueMsg);
            } else if (result.entries[j].itemConfirmationStatus === 'A') {
              $confirmationStatus.html(unConfirmedDelivery);
              $confirmationStatus.removeClass(blueMsg).addClass(orangeMsg);
            } else {
              $confirmationStatus.html(parConfirmedDelivery);
              $confirmationStatus.removeClass(blueMsg).addClass(orangeMsg);
            }


            var dpInput = 'requestedDeliveryDateInput' + result.entries[j].productEntered;
            var $dp = $('#' + dpInput);

            $dp.attr(prevrdd, $dp.val());

            var messages = '',
                htmlData = '';

            $('#rddMsg-' + result.entries[j].productEntered).html(messages);

            if (result.entries[j].entryMessages !== null) {
              for (var msgIndex = 0; msgIndex < result.entries[j].entryMessages.length; msgIndex = msgIndex + 1) {
                var message = result.entries[j].entryMessages[msgIndex],
                    $cartMessage = $('#rddMsg-' + result.entries[j].productEntered);

                if (message.messageClass !== 'error') {
                  htmlData = deliverError + message.messageClass + '">' +
                    '<div class="ph-orange-msg ph-float-left ph-p-1 ph-pr-2 ph-mt-1 ph-mb-1">' + message.statusMessage + '</div>';
                  htmlData = htmlData + '</div>';
                  messages = messages + htmlData;
                }

                if (message.messageClass === 'error') {
                  htmlData = deliverError + message.messageClass + '">' +
                    '<div class="ph-rederror-msg ph-float-left ph-p-1 ph-pr-2 ph-mt-1 ph-mb-1">' + message.statusMessage + '</div>';
                  htmlData = htmlData + '</div>';
                  messages = messages + htmlData;
                }

                $cartMessage.html(messages);
              }
            }
          }
        }

        $('.ph-' + singCheckVal).html(result.confirmedDeliveryDate);

        var $singledatePicker = $('.ph-singlereq__date');

        $singledatePicker.datepicker('setDate', result.confirmedDeliveryDate);
        $singleCheckout.addClass('hidden');
        $('.ph-prod__code_hidden').val('');
        $(disableScroll).css({
          overflow: 'visible'
        });
      },
      error: function() {
        var $datePicker = $('#' + dpId);

        $datePicker.datepicker('setDate', $datePicker.attr(prevrdd));
      }
    });
  }


  function updateDate(singleDate) { // NOSONAR
    $('.ph-vanish-ajax').empty();
    $('.ph-sapaddresserror').empty();
    $.ajax({
      url: ACC.config.encodedContextPath + '/checkout/single//updateDate.json',
      data: {
        reqDate: singleDate
      },
      type: 'POST',
      datatype: 'json',
      success: function(result) {
        hideDatepickerSpinner();

        var scheduleData = '',
            prevrdd = 'data-prev-rdd',
            updatedDate = result.reqDeliveryDate,
            messages = '',
            htmlData = '',
            $singlecheckdatePicker = $('.ph-singlereq__date'),
            scConfirmed = $('#ph-sc_confirmed').val(),
            scParConfirmed = $('#ph-sc_parconfirmed').val(),
            disbutton = 'ph-disable-button',
            scUnConfirmed = $('#ph-sc_unconfirmed').val(),
            $scDeliveryMessage = $('.ph-sc_deliverymesage'),
            weCanDeliver = $('#ph-wecandeliver').val(),
            orderBtn = 'order-button';

        $('.ph-' + singCheckVal).html(updatedDate);
        $('.phi-' + checkDatepick).val(updatedDate);

        if (result.orderConfimationStatus === 'allconfirmed') {
          $scDeliveryMessage.html(scConfirmed);
        } else if (result.orderConfimationStatus === 'partiallyconfirmed') {
          $scDeliveryMessage.html(scParConfirmed);
        } else {
          $scDeliveryMessage.html(scUnConfirmed);
        }

        $singlecheckdatePicker.datepicker('setDate', updatedDate);

        $('#rddMsg').html(messages);

        for (var j = 0; j < result.entries.length; j = j + 1) {
          var prodCodeVal = '.ph-sapdate-' + result.entries[j].productEntered,
              updatedateitem = '',
              produpdatedDateVal = '#ph-updateddnamicvalue-' + result.entries[j].productEntered,
              proddefaultdelivertext = '.ph-defaultdelivertext-' + result.entries[j].productEntered;

          $(produpdatedDateVal).html('');

          var prodCodeText = '#ph-wecandeliver-' + result.entries[j].productEntered;

          var scheduledatacontent = '';

          $('.' + multidelItem).find(storeDate + result.entries[j].productEntered).attr('data-date', updatedDate);

          for (var schedIndex = 0; schedIndex < result.entries[j].scheduleLines.length; schedIndex = schedIndex + 1) {
            scheduledatacontent = scheduledatacontent + '<div class="ph-updateddnamicvalue" id="ph-updateddnamicvalue-' +
              result.entries[j].productEntered + '">';
            scheduleData = scheduleData + result.entries[j].scheduleLines[schedIndex].formattedValue;
            updatedateitem = result.entries[j].scheduleLines[schedIndex].formattedConfirmedDate;
            scheduledatacontent = scheduledatacontent + '<div class="ph-dynamictext ph-float-left">' + weCanDeliver +
              '</div> <div class="ph-multiple__checkout__date ph-multipleschlines ph-float-left">' + result.entries[j].scheduleLines[schedIndex].formattedValue + '</div></div>';
          }


          if (produpdatedDateVal.length > 0) {
            $(prodCodeVal).remove();
            $(proddefaultdelivertext).remove();
            $(prodCodeText).html(scheduledatacontent);
          } else {
            $(prodCodeVal).html(scheduleData);
          }

          scheduleData = '';
          $('#requestedDeliveryDate-' + result.entries[j].productEntered).datepicker('setDate', updatedateitem);

          var dpInput = 'requestedDeliveryDateInput' + result.entries[j].productEntered;
          var $dp = $('#' + dpInput);

          $dp.attr(prevrdd, $dp.val());
        }

        for (var messagecount = 0; messagecount < result.messages.length; messagecount = messagecount + 1) {
          var message = result.messages[messagecount];

          if (message.messageClass !== 'error') {
            htmlData = deliverError + message.messageClass + '">' +
              '<div class="ph-orange-msg ph-float-left ph-p-1 ph-pr-2 ph-mt-1 ph-mb-1">' + message.statusMessage + '</div>';
            htmlData = htmlData + '</div>';
            messages = messages + htmlData;
          }

          if (message.messageClass === 'error') {
            htmlData = deliverError + message.messageClass + '">' +
              '<div class="ph-rederror-msg ph-float-left ph-p-1 ph-pr-2 ph-mt-1 ph-mb-1">' + message.statusMessage + '</div>';
            htmlData = htmlData + '</div>';
            messages = messages + htmlData;
          }

          var $cartMessage = $('#rddMsg');

          $cartMessage.html(messages);
        }

        if (messages !== '' && $('#blockNonPreferFlag').val() === 'true') {
          $('#Place-' + orderBtn).addClass(disbutton);
        } else if ($('#termsCheck').prop('checked') && $('#purchaseOrderNumber').val() !== '' && poNumberCheckMandatory === 'true') {
          $('#Place-' + orderBtn).removeClass(disbutton);
        } else if ($('#termsCheck').prop('checked') && poNumberCheckMandatory === 'false') {
          $('#Place-' + orderBtn).removeClass(disbutton);
        }

        $singleCheckout.addClass('hidden');
        $(disableScroll).css({
          overflow: 'visible'
        });
      },
      error: function() {
        currentDate.html(currentDate);
      }
    });
  }

  $('.ph-req__date').datepicker({
    changeMonth: true,
    changeYear: true,
    closeText: reqDate,
    showButtonPanel: true,
    onSelect: function(dateText, inst) {
      inst.show();
    }

  });

  $(document).on('click', '.reqcalender', function() {
    var dateid = $(this).attr('id'),
        entryNum = $(this).attr('data-entrynumber'),
        reqDateAll = $(this).attr('data-reqdata-all'),
        stringBottom = 'bottom',
        $selfevent = $(this);

    $('.ph-datepicker__' + stringBottom).removeClass('hidden');
    $('.ph-single__checkout-' + dateid).removeClass('hidden');

    setTimeout(function() {
      $selfevent.parents('.' + multidelItem).find('.' + checkoutDatePicker).focus();
    }, 50);

    $('.ui-datepicker-close').attr({
      id: dateid,
      'data-num': entryNum,
      'data-reqdate-all': reqDateAll
    });
    $(disableScroll).css({
      overflow: 'hidden'
    });
    $('.ph-prod__code').val(dateid);
    $('.ph-prod__entry').val(entryNum);
    $('.ph-prod__reqdate-all').val(reqDateAll);
  });

  /* Request Delivery Date for all start*/
  $(document).on('click', '.reqCalenderAll', function() {
    var dateid = $(this).attr('id'),
        entryNum = $(this).attr('data-entrynumber'),
        reqDateAll = $(this).attr('data-reqdata-all'),
        $selfevent = $(this);

    $('.ph-datepicker__bottom').removeClass('hidden');
    $('.ph-single__checkout-' + dateid).removeClass('hidden');

    setTimeout(function() {
      $selfevent.parents('.ph-selectaddress-button').find('.' + checkoutDatePicker).focus();
    }, 50);

    $('.ui-datepicker-close').attr({
      id: dateid,
      'data-num': entryNum,
      'data-reqdate-all': reqDateAll
    });
    $(disableScroll).css({
      overflow: 'hidden'
    });
    $('.ph-prod__code').val(dateid);
    $('.ph-prod__entry').val(entryNum);
    $('.ph-prod__reqdate-all').val(reqDateAll);
  });

  $(document).on('click', '.ph-mymulti-checkout-all', function() {
    if (!$(this).hasClass('hidden')) {
      $(this).parents('.ph-selectaddress-button').find('.' + checkoutDatePicker).focus();
    }
  });

  /* Request Delivery Date for all end*/

  $(document).on('change', '.phi-checkout__datepicker', function() {
    var latestDate = $(this).val();

    $(this).val(latestDate);

    if (new Date(latestDate) <= new Date(currentDate)) {
      $checkoutDatePicker.addClass(dateError);
      $('.ui-priority-secondary').next().addClass(requestDisable);
      $singleCheckout.removeClass('hidden');
    } else {
      $checkoutDatePicker.removeClass(dateError);
      $('.ui-datepicker-close').removeClass(requestDisable);
    }

    $singleCheckoutDate.val(latestDate);
    currentDate.html(latestDate);
    $('.ph-multiple__checkout__date').html(latestDate);
  });

  function closeDatePicker() {
    $singleCheckout.addClass('hidden');
    $(disableScroll).css({
      overflow: 'visible'
    });
  }

  $(document).on('click', '.ui-priority-primary', function() {
    $('.ui-priority-primary').each(function() {
      showDatepickerSpinner();

      var stringDateBottom = 'datepicker__bottom';

      $('.ph-' + stringDateBottom).addClass('hidden');

      var dpId = $('.ph-prod__code').val();
      var prevDate = $('.ph-single__checkout__value').html();
      var prevMultipleDate = $('.ph-multidel-item ').find(storeDate + dpId).attr('data-date');
      var date = $('#requestedDeliveryDate-' + dpId).val();
      var entryNumber = $('.ph-prod__entry').val();
      var reqDateAll = $('.ph-prod__reqdate-all').val();
      var singleDate = $('#requestedDeliveryDate').val(),
          singledeliveryflag = $('#siingledeliveryFlag').val();

      if (prevMultipleDate === date && !$('#ph-multiItem-section').hasClass('hidden') && singledeliveryflag === false) {
        hideDatepickerSpinner();
        closeDatePicker();
      } else if (date && prevMultipleDate !== date) {
        $('.ph-storeDate-' + dpId).attr('data-date', date);
        updateEntryDate(entryNumber, date, dpId, reqDateAll);
      } else if (prevDate === singleDate) {
        $('.ph-spinnerlargesingle').addClass('hidden');
        closeDatePicker();
      } else if (prevDate !== singleDate) {
        updateDate(singleDate);
      }
    });
  });

  $(document).on('click', '.ph-singlecalender', function() {
    var $self = $(this);

    $('.ph-datepicker__bottom').removeClass('hidden');
    $singleCheckout.removeClass('hidden');
    setTimeout(function() {
      $self.parents('#ph-singleItem-section').find('.' + checkoutDatePicker).focus();
    }, 50);
    $(disableScroll).css({
      overflow: 'hidden'
    });
  });

  $(document).on('click', '.ph-mymulti-checkout', function() {
    if (!$(this).hasClass('hidden')) {
      $(this).parents('.' + multidelItem).find('.' + checkoutDatePicker).focus();
    }
  });
  $(document).on('click', '.ph-mysingle-checkout', function() {
    if (!$(this).hasClass('hidden')) {
      $(this).parents('#ph-singleItem-section').find('.' + checkoutDatePicker).focus();
    }
  });
});

$(document).ready(function() {
  var singleCheck = 'single__checkout',
      prioPrim = 'priority-primary',
      $singleCheckout = $('.ph-' + singleCheck),
      $requestButton = $('.ui-' + prioPrim),
      $checkoutButton = $('.ph-checkout-btn'),
      $placeOrderButton = $('.ph-shipping__procceed'),
      disableScroll = 'html, body',
      shipbutdisable = 'ph-shipping__procceed-disable',
      paymentdisable = 'ph-payment__procceed-disable',
      paynow = '#ph-paynow',
      interstitialLoader = '.ph-interstitial-loader',
      orderbtn = '.ph-orderbtn',
      paynowradiocheck = '.ph-paynowradiocheck',
      paymentproceedBtn = '.ph-payment__procceed',
      paynowcontent = '.ph-paynowcontent';

  $(document).on('click', '.ph-datepicker__popup__close', function() {
    $singleCheckout.addClass('hidden');
    $requestButton.trigger('click');
    $(disableScroll).css({
      overflow: 'visible'
    });
  });

  $(document).keydown(function(event) {
    if (event.keyCode === 27) {
      $singleCheckout.addClass('hidden');
      $(disableScroll).css({
        overflow: 'visible'
      });
    }
  });

  if ($('.ph-disablebutton').length > 0) {
    $checkoutButton.attr('disabled', 'disabled');
    $checkoutButton.addClass('ph-disable__button');
    $placeOrderButton.attr('disabled', 'disabled');
    $placeOrderButton.addClass('ph-disable__button');
  }

  if ($('.ph-address-error').length > 0) {
    $placeOrderButton.addClass('ph-disable__checkout');
    $('.ph-address__error').show();
  }


  if ($('.font-centrale-xbold').length === 6) {
    $('.ph-itemlists').css('width', '2px');
  }

  function callWaitingLoader() {
    window.sto = setTimeout(function() {
      $('.ph-popup_overlay').removeClass('hidden');
    }, 1000);
  }

  $(document).ready(function() {
    if (document.getElementById('errorMsgOrder')) {
      $('#checkouthref').addClass('ph-disable-button');
    }
  });

  $(document).on('click', '#Place-order-button', function() {
    var placeOrd = '#placeOrderForm',
        placeBut = '-button';

    $('#Place-order' + placeBut).addClass(shipbutdisable).prop('disabled', true);
    $(interstitialLoader).removeClass('hidden');

    if ($('.ph-consignee-exist').length > 0) {
      if ($('.ph-no-cons-text').is(':visible') || $('.ph-cons-addr').hasClass('ph-selected-add')) {
        $(placeOrd).submit();
      } else {
        $.colorbox({
          width: '685px',
          maxWidth: '90%',
          height: '200px',
          html: $('.ph-noConsigneeConfirmPopup').html(),
          overlayClose: false,
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      }
    } else {
      $(placeOrd).submit();
    }
  });

  function getPaynowDiscount(onlinePaybtn) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/checkout/single/paynowDiscount',
      data: {
        isOnlinePayment: onlinePaybtn
      },
      type: 'POST',
      success: function(data) {
        if (data.paynowDiscount !== null && onlinePaybtn === 'true') {
          $('.ph-discountcontainer').html(data.paynowDiscount.formattedValue);
          $(paynowcontent).removeClass('hidden');
          ACC.common.updateCartDetails(data);

          $(paymentproceedBtn).removeClass(paymentdisable).prop('disabled', false);
          $(interstitialLoader).addClass('hidden');
        } else {
          $(paynowcontent).addClass('hidden');
          ACC.common.updateCartDetails(data);

          $(paymentproceedBtn).removeClass(paymentdisable).prop('disabled', false);
          $(interstitialLoader).addClass('hidden');
        }
      },
      error: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  }

  if ($(paynowradiocheck).length > 0) {
    var accPay = $('#accountPay').attr('data-onlinepay');

    $(orderbtn).addClass(paymentdisable).prop('disabled', true);
    $(interstitialLoader).removeClass('hidden');
    getPaynowDiscount(accPay);
  }

  $(document).on('change', 'input:radio[name=\'paymentType\']', function() {
    var paymentTypeSelected = $('input:radio[name=\'paymentType\']:checked').val(),
        paymentorder = '#ph-paymentOrder',
        paynowbtn = '.ph-paynowbtn';

    if (paymentTypeSelected === 'CARD') {
      $(paymentorder).attr('action', ACC.config.encodedContextPath + '/checkout/single/add-payment-method');
      $(orderbtn).addClass('hidden');
      $(paynowbtn).removeClass('hidden');
    } else {
      $(paymentorder).attr('action', ACC.config.encodedContextPath + '/checkout/single/placeOrderFromPayment');
      $(paynowbtn).addClass('hidden');
      $(orderbtn).removeClass('hidden');
    }
  });
  $(document).on('change', '.ph-paynowradiocheck', function() {
    var onPay = $(this).attr('data-onlinepay');

    $('.ph-payment__procceed').removeClass(paymentdisable).prop('disabled', false);

    if (onPay === 'true') {
      $('.ph-paynowbtn').addClass(paymentdisable).prop('disabled', true);
    } else {
      $(orderbtn).addClass(paymentdisable).prop('disabled', true);
    }

    $(interstitialLoader).removeClass('hidden');
    getPaynowDiscount(onPay);
  });
  $(document).on('click', paynow, function() {
    $(this).addClass(paymentdisable).prop('disabled', true);
    $(interstitialLoader).removeClass('hidden');
    $('#ph-paymentOrder').submit();
  });
  $(document).on('click', '#ph-consigneeconfirm-yes', function() {
    $('#cboxLoadedContent #ph-consigneeconfirm-yes').addClass(shipbutdisable);
    $('#cboxLoadedContent #ph-spinner').removeClass('hidden');
    $('#default_sel').find('.use_address').trigger('click');
    callWaitingLoader();
    $('#placeOrderForm').submit();
  });
  $(document).on('click', '#ph-consigneeconfirm-no', function() {
    var placebutton = '-button';

    $('#Place-order' + placebutton).removeClass(shipbutdisable).prop('disabled', false);
    $.colorbox.close();
  });
});
$(document).ready(function() {
  var checkoutPicker = 'checkout__datepicker',
      disablebtn = 'disable-button';

  $(document).on('click', '.ui-state-default', function() {
    $(this).addClass('ph-date__selection');
    $(this).parents().find('.ui-state-active').removeClass('ui-state-active');
    $('.ui-state-default').not(this).removeClass('ph-date__selection');
    $('.phi-' + checkoutPicker).removeClass('ph-date__error');
    $('.ui-datepicker-buttonpane').children().removeClass('ph-request__disable');
    event.preventDefault();
  });


  $('.ph-single__checkout_date').keypress(function(event) {
    if (event.keyCode === 10 || event.keyCode === 13) {
      event.preventDefault();
    }
  });

  $('.ph-backtotop').on('click', function() {
    $(window).scrollTop(0);
  });

  if ($('.ph-sap-orderBlock').length > 0) {
    $('.ph-checkout-btn').addClass('ph-' + disablebtn);
  }
});
$(function() {
  var fromDate = '.ph-fromdate';
  var toDate = '.ph-todate';
  var quoteDate = '#ph-quote-datepicker';

  if ($(fromDate).length > 0) {
    $(fromDate).datepicker({
      changeMonth: true,
      changeYear: true,
      maxDate: '0',
      dateFormat: $('.ph-orderHistoryDateFormat').val().toLowerCase().replace('yyyy', 'yy'),
      onSelect: function(selected) {
        $(toDate).datepicker('option', 'minDate', selected);
      }
    });
  }

  if ($(toDate).length > 0) {
    $(toDate).datepicker({
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      maxDate: '0',
      dateFormat: $('.ph-orderHistoryDateFormat').val().toLowerCase().replace('yyyy', 'yy'),
      onSelect: function(selected) {
        $(fromDate).datepicker('option', 'maxDate', selected);
      }
    });
  }

  $('.ph-fromdatecalender').on('click', function() {
    $(fromDate).datepicker('show');
  });
  $('.ph-todatecalender').on('click', function() {
    $(toDate).datepicker('show');
  });

  $(document).on('mouseout', '.ph-netprice__icon', function() {
    $(this).siblings('.ph-netprice__popup').addClass('hidden');
  });
  $(document).on('mouseover', '.ph-netprice__icon', function() {
    $(this).siblings('.ph-netprice__popup').removeClass('hidden');
  });

  if ($(quoteDate).length > 0) {
    var dateObjq = new Date(),
        hdTimeq = dateObjq.getTime(),
        maxFutq = $(quoteDate).attr('data-quotedate'),
        maxFutqNew = '';

    if (maxFutq === '') {
      maxFutqNew = '0';
    } else {
      maxFutqNew = maxFutq;
    }

    var maxFutMilq = parseInt(maxFutqNew, 10) * parseInt(86400000, 10),
        dateObjMaxq = new Date();

    dateObjMaxq.setTime(parseInt(hdTimeq, 10) + parseInt(maxFutMilq, 10));

    $(quoteDate).datepicker({
      changeMonth: true,
      changeYear: true,
      defaultDate: Number(maxFutq),
      minDate: dateObjMaxq,
      dateFormat: $('.ph-quoteDateFormat').val().toLowerCase().replace('yyyy', 'yy')
    });
    $(quoteDate).datepicker('setDate', dateObjMaxq);
  }
});
/* eslint-enable max-lines-per-function */
/* eslint-enable id-length */
/* eslint-enable no-use-before-define */
/* eslint-enable vars-on-top */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable require-jsdoc */
/* eslint-enable  max-lines*/
/* eslint-enable  max-statements*/
/* eslint-enable max-len */
/* eslint-enable complexity */
/* eslint-enable no-inline-comments */
/* eslint-enable line-comment-position */
